// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-Tmt","question":"styles_question__ICbAV","description":"styles_description__gIERx"};